const apiBaseUrl = (process.env.REACT_APP_API_URL || 'https://api.amresidence.me').replace(/\/$/, '');

export function getApiUrl(pathname) {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${apiBaseUrl}${normalizedPath}`;
}

export function getPublicApiErrorMessage(message, fallback) {
  if (typeof message !== 'string' || !message.trim() || /guesty/i.test(message)) {
    return fallback;
  }

  return message.trim();
}
